import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  currentPage: number = 1;
  totalPages: number = 0;
  recordsPerPage: number = 10;
  pagesToShow: number = 5;

  constructor() {}

  updatePagination<T>(items: T[], searchText: string, searchFields: string[]): T[] {
    if (!searchText) {
      this.totalPages = Math.ceil(items.length / this.recordsPerPage);
      return items;
    }
  
    const searchCriteria = searchText.split(',').map(criterio => criterio.trim().toLowerCase());
  
    const filteredList = items.filter((item) =>
      searchFields.some((field) => {
        const fieldValue = (item as any)[field];
        // Verificamos si el valor del campo no es undefined o null
        if (fieldValue !== undefined && fieldValue !== null) {
          return searchCriteria.some((criterio) => fieldValue.toString().toLowerCase().includes(criterio));
        }
        return false; // Si es undefined o null, lo ignoramos
      })
    );
  
    this.totalPages = Math.ceil(filteredList.length / this.recordsPerPage);
    return filteredList;
  }

  get pages(): number[] {
    const start = Math.max(1, this.currentPage - Math.floor(this.pagesToShow / 2));
    const end = Math.min(this.totalPages, start + this.pagesToShow - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  nextPage(itemsLength: number) {
    const totalItemsShown = this.currentPage * this.recordsPerPage;
    if (totalItemsShown < itemsLength) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  getRange(itemsLength: number): string {
    const startIndex = (this.currentPage - 1) * this.recordsPerPage + 1;
    const endIndex = Math.min(this.currentPage * this.recordsPerPage, itemsLength);
    return `${startIndex} - ${endIndex}`;
  }
}
